'use es6';

import { PureComponent } from 'react';
import styled from 'styled-components';
import { microInputMixin } from './internal/inputMixins';
import UITimeInput from './UITimeInput';
import { jsx as _jsx } from "react/jsx-runtime";
const TimeInputWrapper = styled(UITimeInput).withConfig({
  displayName: "UIMicroTimeInput__TimeInputWrapper",
  componentId: "cpinqg-0"
})(["display:inline-block;"]);
const MicroInput = styled(UITimeInput.defaultProps.Input).withConfig({
  displayName: "UIMicroTimeInput__MicroInput",
  componentId: "cpinqg-1"
})(["&&{", ";}"], microInputMixin);
class UIMicroTimeInput extends PureComponent {
  render() {
    return /*#__PURE__*/_jsx(TimeInputWrapper, Object.assign({
      iconSize: 14,
      inputWidth: 124
    }, this.props));
  }
}
UIMicroTimeInput.displayName = 'UIMicroTimeInput';
UIMicroTimeInput.defaultProps = Object.assign({}, UITimeInput.defaultProps, {
  Input: MicroInput
});
UIMicroTimeInput.propTypes = UITimeInput.propTypes;
export default UIMicroTimeInput;